import React from "react";
import { Link } from "react-scroll";
import { motion } from "framer-motion";
import AromaMilk from "../assets/aromamilk.png";
import JacoBar from "../assets/jcobar.webp";
import Cylinder from "../assets/cylinder.webp";

const cards = [
  {
    id: 1,
    title: "Healthy Cool Products",
    subtitle: "Every Day",
    image: JacoBar,
    textColor: "text-white",
  },
  {
    id: 2,
    title: "Aroma Milk",
    subtitle: "Added Daily",
    image: AromaMilk,
    textColor: "text-pink-400",
  },
  {
    id: 3,
    title: "We Deliver Cylinder",
    subtitle: "Door Delivery",
    image: Cylinder,
    textColor: "text-sky-400",
  },
];

const HeadlineCards = () => {
  return (
    <motion.div
      className="max-w-[1640px] mx-auto p-4 py-12 grid md:grid-cols-3 gap-6"
      initial="hidden"
      animate="visible"
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { staggerChildren: 0.2, duration: 0.8 },
        },
      }}
    >
      {cards.map((card) => (
        <motion.div
          key={card.id}
          className="rounded-xl relative overflow-hidden shadow-lg"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          whileHover={{ scale: 1.05 }}
        >
          {/* Overlay */}
          <motion.div
            className="absolute w-full h-full bg-black/60 rounded-xl text-white flex flex-col justify-between p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div>
              <p className="font-bold text-2xl">{card.title}</p>
              <p className={`font-bold text-lg ${card.textColor}`}>{card.subtitle}</p>
            </div>
            <motion.button
              className="border-white bg-white text-black py-2 px-4 rounded-lg self-start"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              Order Now
            </motion.button>
          </motion.div>
          {/* Image */}
          <motion.img
            src={card.image}
            alt={card.title}
            className="max-h-[250px] md:max-h-[250px] w-full h-full object-cover rounded-xl"
            whileHover={{ scale: 1.1, rotate: 2 }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default HeadlineCards;
